import { FoodOption, PetWantsFormula, ValuePointKey } from './cost-calculator.types';

export const DEFAULT_FOOD_ID = 'blue-buffalo';

export const DAYS_PER_MONTH = 30.4;

export const PET_WANTS: PetWantsFormula = {
  name: 'Pet Wants Chicken Formula',
  kcalPerCup: 457,
  costPerCup: 0.80,
  cupsPerPound: 4,
  pricePerPound: 3.20
};

export const DEFAULT_FILLERS_TEXT = 'Fillers like corn, wheat, soy, gluten, and animal by-products are often worth avoiding because they can add bulk without reflecting the cleaner ingredient approach many pet owners want. Pet Wants does not use these fillers.';

export const VALUE_POINT_NAMES: Record<ValuePointKey, string> = {
  freshness: 'small-batch freshness',
  fillers: 'filler ingredients',
  local: 'local convenience',
  smallerServing: 'smaller equal-calorie serving'
};

export const QUICK_CUPS = [1, 2, 3, 4];

export const FOODS: FoodOption[] = [
  {
    id: 'blue-buffalo',
    name: 'Blue Buffalo — Life Protection',
    kcalPerCup: 376,
    costPerCup: +(0.63 * 376 / 457).toFixed(2),
    cupsPerPound: 4.35,
    bagSizes: [15, 24, 30],
    tags: ['premium', 'national', 'shelf'],
    fillers: ['gluten']
  },
  {
    id: 'royal-canin',
    name: 'Royal Canin — Large Adult',
    kcalPerCup: 347,
    costPerCup: +(1.09 * 347 / 457).toFixed(2),
    cupsPerPound: 137 / 30,
    bagSizes: [17, 30, 40],
    tags: ['premium', 'vet', 'national', 'shelf'],
    fillers: ['corn', 'wheat', 'animal by-products']
  },
  {
    id: 'hills-science-diet',
    name: 'Hill\'s Science Diet — Adult Sensitive Skin',
    kcalPerCup: 394,
    costPerCup: +(0.80 * 394 / 457).toFixed(2),
    cupsPerPound: 4.2,
    bagSizes: [15, 30],
    tags: ['premium', 'vet', 'national', 'shelf'],
    fillers: ['soy']
  },
  {
    id: 'rachael-ray',
    name: 'Rachael Ray Nutrish — Adult',
    kcalPerCup: 350,
    costPerCup: +(0.41 * 350 / 457).toFixed(2),
    cupsPerPound: 4.5,
    bagSizes: [14, 28, 40],
    tags: ['mainstream', 'national', 'shelf'],
    fillers: ['corn', 'wheat', 'soy']
  },
  {
    id: 'purina-one',
    name: 'Purina ONE — Adult',
    kcalPerCup: 383,
    costPerCup: +(0.46 * 383 / 457).toFixed(2),
    cupsPerPound: 4.5,
    bagSizes: [16.5, 31.1],
    tags: ['mainstream', 'national', 'shelf'],
    fillers: ['corn', 'wheat', 'soy', 'animal by-products']
  },
  {
    id: 'iams',
    name: 'IAMS — Minichunks',
    kcalPerCup: 373,
    costPerCup: 0.35,
    cupsPerPound: 4.3,
    bagSizes: [15, 30],
    tags: ['mainstream', 'national', 'shelf'],
    fillers: []
  },
  {
    id: 'purina-pro-plan',
    name: 'Purina Pro Plan — Adult Complete Essentials',
    kcalPerCup: 419,
    costPerCup: 0.49,
    cupsPerPound: 4.25,
    bagSizes: [6, 18, 35],
    tags: ['premium', 'vet', 'national', 'shelf'],
    fillers: []
  },
  {
    id: 'taste-of-the-wild',
    name: 'Taste of the Wild — High Prairie',
    kcalPerCup: 422,
    costPerCup: 0.53,
    cupsPerPound: 4.0,
    bagSizes: [14, 28],
    tags: ['premium', 'national', 'shelf'],
    fillers: []
  },
  {
    id: 'orijen',
    name: 'ORIJEN — Original',
    kcalPerCup: 470,
    costPerCup: 1.01,
    cupsPerPound: 4.0,
    bagSizes: [4.5, 23.5],
    tags: ['premium', 'national', 'shelf'],
    fillers: []
  },
  {
    id: 'acana',
    name: 'ACANA — Adult Dog',
    kcalPerCup: 377,
    costPerCup: 0.68,
    cupsPerPound: 4.1,
    bagSizes: [4.5, 25],
    tags: ['premium', 'national', 'shelf'],
    fillers: []
  },
  {
    id: 'wellness',
    name: 'Wellness — Complete Health Adult',
    kcalPerCup: 405,
    costPerCup: 0.63,
    cupsPerPound: 4.15,
    bagSizes: [5, 12, 26],
    tags: ['premium', 'national', 'shelf'],
    fillers: []
  },
  {
    id: 'nutro',
    name: 'NUTRO — Adult Chicken & Brown Rice',
    kcalPerCup: 332,
    costPerCup: 0.42,
    cupsPerPound: 4.4,
    bagSizes: [12, 30],
    tags: ['premium', 'national', 'shelf'],
    fillers: []
  },
  {
    id: 'other',
    name: 'Other — enter your own',
    isCustom: true,
    kcalPerCup: 380,
    costPerCup: 0.55,
    cupsPerPound: 4.2,
    bagSizes: [15, 25, 30],
    tags: ['custom'],
    fillers: []
  }
];
